import layout from 'app/store/layout';
import bookings from 'app/store/bookings';
import { handleErrors } from 'app/store/utils';

const { setLoader, createToast, setErrorApi } = layout.actions;
const { setBooking } = bookings.actions;

export { setLoader, handleErrors, createToast, setErrorApi, setBooking };
